export default __webpack_public_path__ + "static/media/doner_logo_vecses.d66c4f8b.png";